export const Divider = () => {
  return (
    <div
      class="divider"
      style={css`
        width: 100%;
        height: 1px;
        border-bottom: 1px solid var(--on-surface-border);
      `}
    />
  );
};
